import { PlusCircle, ThreeDotsVertical } from "react-bootstrap-icons";
import { useNavigate, useParams } from "react-router-dom";
import { Column } from "../../Components/Tables/Table";
import { header } from "../../Shared/Cards/Card.type";
import { prepareSearchColumns } from "../../Utility/Utility";
import { useEffect, useState } from "react";
import CommonConfirmationModal from "../../Components/Modals/CommonConfirmationModal";
import { ApiResponse } from "../../model/common/apiResponse";
import toast from "react-hot-toast";
import { changeStatus } from "../setup/service/setup.service";
import SetupList from "../setup/list/List";
import { SupplierOverViewProps } from "./model/Supplier.type";
import { deleteSupplier } from "./service/suppliers.service";
import useUserStore, { userAccess } from "../../store/auth/userStore";

export default function SuppliersOverview() {
  const pageName = "Suppliers";
  const addUrl = "/account/client/supplier/add"
  const listUrl = "/account/client/supplier/list-view"
  const gridUrl = "/account/client/supplier/grid-view"
  const statusUpdateEndpoint = "suppliers"
  const ListingEndpoint = "suppliers/query";

  const navigation = useNavigate();
  const { viewtype } = useParams<{ viewtype: string }>();
  const [statusData, setStatusData] = useState<any>();
  const [data, setData] = useState<any>(null);
  const [userAccess, setUserAccess] = useState<userAccess | null>(null);
  const { currentUser, fetchUser } = useUserStore();
  const [loading, setLoading] = useState(true);
  const [confirmModalData, setConfirmModalData] = useState({
    supplier_id: 0,
    showconfModal: false,
    message: ''
  });
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const handleconfShow = () => {
    setConfirmModalData((prevData) => ({
      ...prevData,
      showconfModal: true
    }));
  };
  const handleconfClose = () => {
    setConfirmModalData({
      supplier_id: 0,
      showconfModal: false,
      message: ``
    });
  }
  const handelEditAction = (data: any) => {
    navigation(`/account/client/supplier/edit/${data.id}`);
  };


  const onModalSubmit = (isAccept: boolean) => {
    if (confirmModalData.supplier_id !== 0 && isAccept) {
      deleteSupplier(confirmModalData.supplier_id).then((response: ApiResponse<any>) => {
        if (response.status == 200) {
          toast.success("Supplier deleted successfully");
          setRefreshTrigger(prev => prev + 1);
        } else {
          toast.error("Failed to delete supplier");
        }
      });
    }
    handleconfClose();
  };
  const handelDeleteAction = (data: SupplierOverViewProps) => {
    setConfirmModalData({
      supplier_id: data.id,
      showconfModal: true,
      message: `Are you sure you want to delete supplier '${data.name}'?`
    });
    console.log('data', data);

  }
  const handelInactiveAction = (data: any, isActive: boolean) => {
    const payload = {
      "is_active": isActive
    }
    changeStatus(`${statusUpdateEndpoint}/${data.id}`, payload).then((response: ApiResponse<any>) => {

      if (response.status == 200) {
        setStatusData(response.data);
        toast.success('Supplier status updated successfully!', {
          duration: 5000,
        });
      } else {
        toast.error('Failed to update Supplier status!', {
          duration: 5000,
        });
      }


    })
  };
  let columns: Column[]
  if (viewtype === "list-view") {
    columns = [
      {
        name: "Supplier Code",
        selector: (row: SupplierOverViewProps) => (
          <span className="cursor-pointer text-primary" onClick={() => getDetails(row)}>
            {row.code ? row.code : '-'}
          </span>
        ),
      },
      {
        name: "Suppliers Name",
        selector: (row: SupplierOverViewProps) => row.name ? row.name : '-',
      },
      {
        name: "City",
        selector: (row: SupplierOverViewProps) => row.city ? row.city : '-',
      },
      {
        name: "State",
        selector: (row: SupplierOverViewProps) => row.state_province ? row.state_province : '-',
      },
      {
        name: "Status",
        selector: (row: SupplierOverViewProps) => {
          return row.is_active === 1 ? (
            <span className="badge text-bg-light border border-2 px-3 border-info-subtle">
              Active
            </span>
          ) : (
            <span className="badge text-bg-light border border-2 px-3 border-danger-subtle">
              Inactive
            </span>
          );
        },
      },
      {
        name: <></>,
        selector: (row: any) => (
          <>
            <span
              className="cursor-pointer dropdown-toggle action-menu"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <ThreeDotsVertical />
            </span>
            <ul className="dropdown-menu action-items">
              <li
                className="cursor-pointer ms-3 mb-1"
                onClick={() => handelEditAction(row)}
              >
                Edit
              </li>
              <li
                className="cursor-pointer ms-3 mb-1"
                onClick={() => handelInactiveAction(row, !row.is_active)}
              >
                {row.is_active ? 'Inactive' : 'Active'}
              </li>
              {
                userAccess && userAccess?.is_spherewms_admin ? (
                  <li
                    className="cursor-pointer ms-3 mb-1"
                    onClick={() => handelDeleteAction(row)}
                  >
                    Delete
                  </li>
                ) : (
                  <></>
                )
              }
            </ul>
          </>
        ),
      },
    ];
  } else {
    columns = [
      {
        name: "Name",
        selector: (row: SupplierOverViewProps) => row.contact_name,
      },
      {
        name: "Email",
        selector: (row: SupplierOverViewProps) => row.contact_email,
      },
      {
        name: "Contact",
        selector: (row: SupplierOverViewProps) => row.contact_phone,
      },
      {
        name: "State",
        selector: (row: SupplierOverViewProps) => row.state_province,
      },
    ];
  }

  const headers: header[] = [
    {
      name: "Client Name",
      selector: (row: SupplierOverViewProps) =>
        row.name + "(" + row.code + ")",
    },
  ];
  const db_columns = [
    {
      "data": "supplier.id"
    },
    {
      "data": "supplier.code"
    },
    {
      "data": "supplier.name"
    },
    {
      "data": "supplier.city"
    },
    {
      "data": "supplier.state_province"
    },
    {
      "data": "supplier.is_active"
    },
    {
      "data": "supplier.contact_name"
    },
    {
      "data": "supplier.contact_phone"
    },
    {
      "data": "supplier.contact_email"
    },

  ];
  const exclude_columns: any = ["is_active"];
  const search_columns = exclude_columns ? prepareSearchColumns(db_columns, exclude_columns) : [];
  const sorting_order = [
    {
      column: "supplier.id",
      dir: "desc",
    },
  ];
  const getDetails = (item: any) => {
    navigation(`/account/client/supplier/details/${item.id}`);
  };

  useEffect(() => {
      setLoading(true);
      fetchUser().then((user: userAccess | null) => {
        setUserAccess(user);
      }).then(() => {
        setLoading(false);
      })
  }, [fetchUser])

  const handleDataChange = (data: any) => {
    setData(data);
  };

  return (
    <>
      <SetupList
        pageName={pageName}
        columns={columns}
        addUrl={addUrl}
        listUrl={listUrl}
        gridUrl={gridUrl}
        viewtype={viewtype || "grid-view"}
        headers={headers}
        getDetails={getDetails}
        search_columns={search_columns}
        db_columns={db_columns}
        update_status_url={statusUpdateEndpoint}
        statusData={statusData}
        setStatusData={setStatusData}
        onDataChange={handleDataChange}
        data={data}
        refreshTrigger={refreshTrigger}
        handelEditAction={handelEditAction}
        listEndpoint={ListingEndpoint}
        sorting_order={sorting_order}
      />
      <CommonConfirmationModal
        customClassName="header-border"
        show={confirmModalData.showconfModal}
        confirmBtnText="YES"
        cancelBtnText="NO"
        content={<> {confirmModalData.message} </>}
        onModalSubmit={onModalSubmit}
      />
    </>
  )
}
